<div>
	<img class="qr" [src]="qrCodeImgUrl" />

	<div *ngIf="hideImageUrl" class="link">
		<a [href]="qrCodeImgUrl">{{ qrCodeImgUrl }}</a>
		<div *ngIf="entity?.status === 'draft'" class="warning message">
			{{ 'HELP.QR_CODE_WILL_NOT_WORK_WITH_DRAFT' | translate : {mediatype: (type)} }}
		</div>
	</div>

	<div *ngIf="!hideImageUrl" class="link">
		<strong>{{'IMAGE_URL' | translate }}</strong>:<br />
		{{ qrCodeImgUrl }}
		<br /><br />
		<strong>{{'LINKS_TO' | translate }}</strong>:<br />
		{{ redirectUrl }}
		<div *ngIf="entity?.status === 'draft'" class="warning message">
			{{ 'HELP.QR_CODE_WILL_NOT_WORK_WITH_DRAFT' | translate : {mediatype: (type)} }}
		</div>
	</div>

	<div class="buttons">
		<a class="button" download target="_blank" [href]="qrCodeImgUrl + '?forceDownload'">
			<i class="fa fa-download"></i> {{'DOWNLOAD' | translate }}
		</a>

		<a class="button" target="_blank" [href]="qrCodeImgUrl">
			<i class="fa fa-external-link"></i> {{'OPEN_IN_NEW_WINDOW' | translate }}
		</a>

		<a class="button" (click)="copyText(qrCodeImgUrl)">
			<i class="fa fa-copy"></i> {{ (hideImageUrl ? 'COPY_URL' : 'COPY_IMAGE_URL') | translate }}
		</a>
	</div>
</div>
